import PlaylistAddIcon from '@atlaskit/icon-lab/core/playlist-add';
import * as React from 'react';

export function SvgPlaylistAdd() {
  return (
    <PlaylistAddIcon label="Add to playlist icon" testId="ads-refreshed-icon" />
  );
}
